import { z } from 'zod';

import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';

const AssetParametersSchema: z.ZodSchema<ObjectForSelection> = z.lazy(() =>
  z.object({
    label: z.string(),
    id: z.number()
  })
);

export const AssetTypeSchema = z.object({
  id: z.number(),
  name: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите название типа объекта' })
    .max(40, { message: 'До 40 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  parameters: z.array(AssetParametersSchema)
});
